module.exports = __webpack_public_path__ + "static/media/camera.84392dbf.svg";